import { useFilterJobs } from "@/providers/contexts";
import { Autocomplete } from "@/components/atoms";
import { useJobPostFilterOptions } from "@/hooks/jobPosts/useJobPostFilterOptions";
import { AutocompleteOption } from "@/components/atoms/Autocomplete";
import { useMemo } from "react";

export interface DateFilterProps {
  dateType: "posted" | "updated";
}
export const DateFilter = ({ dateType }: DateFilterProps) => {
  const { filters: jobPostFilters, loading: jobPostFiltersLoading } =
    useJobPostFilterOptions();
  const options = jobPostFilters?.dateOptions ?? [];

  const { filters, dispatch, loading } = useFilterJobs();
  const { selectedDatePostedOption, selectedDateUpdatedOption } = filters;

  const componentName = dateType === "posted" ? "date-posted" : "date-updated";
  const inputLabel = dateType === "posted" ? "Date Posted" : "Date Updated";

  const selectedOptions =
    dateType === "posted"
      ? (selectedDatePostedOption ?? null)
      : (selectedDateUpdatedOption ?? null);

  const mappedOptions: AutocompleteOption[] = useMemo(() => {
    return options.map(option => ({
      key: Number(option.value),
      value: option.label,
      display: option.label,
    }));
  }, [options]);

  const selectedOption =
    mappedOptions.find(
      mappedOption => Number(mappedOption.key) === selectedOptions?.value,
    ) ?? null;

  return (
    <Autocomplete
      componentName={componentName}
      inputLabel={inputLabel}
      options={mappedOptions}
      value={selectedOption}
      onChange={(_, newValue) => {
        if (!newValue) {
          dispatch({
            type: "SET_FILTERS",
            payload: {
              [dateType === "posted"
                ? "selectedDatePostedOption"
                : "selectedDateUpdatedOption"]: null,
            },
          });
          return;
        }

        const selected = options.find(
          opt => opt.value === Number((newValue as AutocompleteOption)?.key),
        );

        if (!selected) return;

        dispatch({
          type: "SET_FILTERS",
          payload: {
            [dateType === "posted"
              ? "selectedDatePostedOption"
              : "selectedDateUpdatedOption"]: selected,
          },
        });
      }}
      loading={loading || jobPostFiltersLoading}
    />
  );
};
